export default __webpack_public_path__ + "static/media/@diego.oliveiracosta.0a822edc.PNG";